import Index from "./components/Index"
import Export from "./components/Export"
import Import from "./components/Import"

let module = "data"

export default [
  { path: "data", component: Index, meta: { module: module, permissions: ["all"] } },
  { path: "data/export", component: Export, meta: { module: module, permissions: ["all"] } },
  { path: "data/import", component: Import, meta: { module: module, permissions: ["all"] } }
]
